import { apiPost, apiPatch } from "./client";

export function postAccount(data) {
  return apiPost("/accounts/", data);
}

export function patchAccount(data) {
  return apiPatch("/accounts/", data);
}
